<template>
  <div>
    <TimesRoundedSmall v-if="val === '0'" />
    <CheckRoundedSmall v-else-if="val === '1'" />
    <span v-else>{{ val }}</span>
  </div>
</template>

<script>
export default {
  name: 'BooleanIconOrDescription',

  props: {
    val: {
      type: String,
      required: true,
    },
  },
}
</script>
